import { createFileRoute } from "@tanstack/react-router";

import TeamFormPage from "~/pages/friends/TeamFormPage.tsx";

export const Route = createFileRoute("/_auth/friends/teams/create")({
    component: TeamFormPage,
});
